import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/setup/")({
  component: SetupIndex,
});

function SetupIndex() {
  const { group_id } = Route.useParams();
  return <Navigate to="/fermentations/$group_id/setup/preparation" params={{ group_id }} replace />;
}
